const enum FormMode {
    None = 0,
    New = 1,
    Edit = 2,
    Add = 3,
}

export default FormMode;